import type { UpdateCauseMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { UpdateCauseDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

import type { UpdateCauseInput } from './types';

export const useUpdateCause = createMutationHook({
  name: 'updateCause',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.cause.update.mutationOptions({ onSuccess }),
  mapInput: (variables: UpdateCauseInput): UpdateCauseInput => ({
    Id: variables.Id ?? '',
    ParentIssueId: variables.ParentIssueId ?? '',
    Title: variables.Title ?? '',
    Description: variables.Description,
    Significance: variables.Significance,
    CustomAttributeData: variables.CustomAttributeData ?? null,
    OriginalTimestamp: variables.OriginalTimestamp ?? '',
  }),
  invalidate: (trpc) => [
    trpc.frontend.cause.register.queryKey(),
    trpc.frontend.cause.getById.queryKey(),
    trpc.frontend.cause.getByParentIssueId.queryKey(),
  ],
  mapResponse: (): UpdateCauseMutation => ({
    update_cause: {
      __typename: 'cause_mutation_response',
      affected_rows: 1,
    },
  }),
  graphqlDocument: UpdateCauseDocument,
  graphqlVariables: (variables: UpdateCauseInput) => ({
    ...variables,
  }),
  validateGraphqlResponse: (data) => {
    if (data.update_cause?.affected_rows !== 1) {
      throw new Error(
        'Records not updated. Record may have been updated by another user'
      );
    }
  },
  evictFields: ['cause', 'cause_aggregate'],
});
